import { KeyValuePair } from "../models/models";

export const textSize: KeyValuePair<number>[] = [
  { id: 7, name: '7 px' },
  { id: 8, name: '8 px' },
  { id: 9, name: '9 px' },
  { id: 10, name: '10 px' },
  { id: 11, name: '11 px' },
  { id: 12, name: '12 px' },
  { id: 13, name: '13 px' },
  { id: 14, name: '14 px' },
  { id: 15, name: '15 px' },
  { id: 16, name: '16 px' },
  { id: 18, name: '18 px' },
  { id: 20, name: '20 px' },
  { id: 22, name: '22 px' },
  { id: 24, name: '24 px' },
  { id: 28, name: '28 px' },
  { id: 32, name: '32 px' },
];
